import apiClient, { type PagedResponse } from '../../client'
import type { FuelTypeItem, UpdateFuelTypeRequest } from '../../models/maestros.models'

const BASE_PATH = '/maestros/fuel-types'

export const fuelTypesService = {
  async getAll(params?: {
    page?: number
    pageSize?: number
    search?: string
  }): Promise<PagedResponse<FuelTypeItem>> {
    return apiClient.get<PagedResponse<FuelTypeItem>>(BASE_PATH, params)
  },
  async update(id: number, data: UpdateFuelTypeRequest): Promise<FuelTypeItem> {
    return apiClient.put<FuelTypeItem, UpdateFuelTypeRequest>(`${BASE_PATH}/${id}`, data)
  },
}
